<template>
  <div class="title" :style="{background:(titleNav=='特殊实力'?'':'#F5F2F5') }">
    <div class="titlet" :style="{color:(titleNav=='特殊实力'?'#fff':'#333') }">{{ titleNav }}</div>
    <div class="titleText" :style="{color:(titleNav=='特殊实力'?'#fff':'#333') }">{{ titleTextNav }}</div>
  </div>
</template>

<script>
export default {
	name: 'NavTiltle',
  data() {
    return {
		title: "商业场景",
		titleText:'BUSINESS SCENE',
	};
  },
  props: ["titleNav","titleTextNav"]
};
</script>
<style lang="less" scoped>
@media screen and (min-width: 768px) {    // pc
	.title {
		width: 100%;
		// height: 273px
		height: 271px;
		// background-color: #565D64;
    background: #F5F2F5;
    background: rgba(255,255,255,.0);
	  .titlet {
	    font-size: 30px;
	    font-family: PingFangSC-Medium, PingFang SC;
	    font-weight: 500;
	    color: #333333;
	    // line-height:16.9375rem;
	    line-height: 30px;
	    letter-spacing: 7px;
	    text-align: center;
	    position: relative;
	    transform: translate(-50%, -40%);
	    top: 40%;
	    left: 50%;
	  }
	  .titleText {
	    font-size: 20px;
	    font-family: PingFangSC-Regular, PingFang SC;
	    font-weight: 400;
	    color: #333333;
	    line-height: 28px;
	    letter-spacing: 13px;
	    text-align: center;
	    position: relative;
	    transform: translate(-50%, -50%);
	    top: 50%;
	    left: 50%;
	  }
	}
}
@media screen and (max-width: 767px) {    // mobile
 .title {
 	width: 100%;
 	height: 114px;
 	// background-color: #565D64;
   .titlet {
     font-size: 18px;
     font-family: PingFangSC-Medium, PingFang SC;
     font-weight: 500;
     color: #333333;
     // line-height:16.9375rem;
     line-height: 30px;
     letter-spacing: 6px;
     text-align: center;
     position: relative;
     transform: translate(-50%, -40%);
     top: 40%;
     left: 50%;
   }
   .titleText {
     font-size: 10px;
     font-family: PingFangSC-Regular, PingFang SC;
     font-weight: 400;
     color: #333333;
     line-height: 28px;
     letter-spacing: 6px;
     text-align: center;
     position: relative;
     transform: translate(-50%, -45%);
     top: 45%;
     left: 50%;
   }
 }
}
</style>
